import { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import InvoiceList from "./InvoiceList";

// global
import { projectStore } from "../../store/Store";

// assets and css
import Add from "../../assets/add.svg";
import GenerateInvoice from "./GenerateInvoice";

import { a11yProps, CustomTabPanel } from "../../components/TabPanels";

export default function CustomerInvoiceTabs() {
  // global
  const currentProject = projectStore((data) => data.currentProject);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices,
  );
  const projectCustomerInvoiceTotals = projectStore(
    (data) => data.projectCustomerInvoiceTotals,
  );

  // local
  const [value, setValue] = useState(0);
  const [assetsExist, setAssetsExist] = useState(false);
  const [freightExist, setFreightExist] = useState(false);
  const [triggerInvoice, setTriggerInvoice] = useState(false);
  const [isAsset, setIsAsset] = useState(false);

  const handleChange = (_, newValue) => {
    setValue(newValue);
    if (value === 1) {
      setIsAsset(false);
    } else if (value === 0) {
      setIsAsset(true);
    }
  };

  // determine if asset invoices/freight invoices exist
  useEffect(() => {
    if (projectCustomerInvoices) {
      const a = projectCustomerInvoices.filter((x) => x.is_asset === true);
      const f = projectCustomerInvoices.filter((x) => x.is_asset === false);
      if (a.length > 0) {
        setAssetsExist(true);
      }
      if (f.length > 0) {
        setFreightExist(true);
      }
    }
  }, [projectCustomerInvoices, setAssetsExist, setFreightExist]);

  return (
    <div className="container-fluid">
      <Box sx={{ width: "100%", margin: "20px 0 0 0" }}>
        <div className="d-flex justify-content-between project-header">
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Freight Invoices"
                {...a11yProps(1)}
                sx={{ fontWeight: "bold", fontSize: "1rem" }}
              />
              <Tab
                label="Asset Invoices"
                {...a11yProps(0)}
                sx={{ fontWeight: "bold", fontSize: "1rem" }}
              />
            </Tabs>
          </Box>
          {!currentProject.project.archived && (
            <img
              src={Add}
              alt="add"
              onClick={() => setTriggerInvoice(true)}
              className="project-delete-image"
            />
          )}
        </div>
        <CustomTabPanel value={value} index={0}>
          {freightExist &&
          projectCustomerInvoices &&
          projectCustomerInvoiceTotals ? (
            <InvoiceList isAsset={isAsset} />
          ) : (
            <div>No Freight Invoices have been added</div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {assetsExist &&
          projectCustomerInvoices &&
          projectCustomerInvoiceTotals ? (
            <InvoiceList isAsset={isAsset} />
          ) : (
            <div>No Asset Invoices have been added</div>
          )}
        </CustomTabPanel>
      </Box>
      {triggerInvoice && (
        <GenerateInvoice
          setTriggerInvoice={setTriggerInvoice}
          isAsset={isAsset}
        />
      )}
    </div>
  );
}
